import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import moment from "moment";
import DayTab from "../../../components/Interventions/DayTab";
import { setSelectedDay, setFilteredAndSortedInterventions } from "../../../redux/intervention/interventionActions";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { arraysAreSame } from "../../../lib/array_helper";

const styles = {
    root: {
        minWidth: "40px",
        padding: 0,
    },
};

function TabContainer({ children, dir }) {
    return (
        <Typography component="div" dir={dir}>
            {children}
        </Typography>
    );
}

class DailyListMode extends Component {
    constructor(props) {
        super(props);

        const nbDaysToDisplay = 7;

        this.state = {
            nbDaysToDisplay: nbDaysToDisplay,
            selectedTab: parseInt(nbDaysToDisplay / 2, 10),
            days: [],
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        let selectedTabChanged = this.state.selectedTab !== nextState.selectedTab;
        let selectedDayChanged =
            this.props.interventionsFilters.selectedDay !== nextProps.interventionsFilters.selectedDay;
        let daysChanged = this.state.days !== nextState.days;
        let filteredAndSortedInterventionsChanged = !arraysAreSame(
            this.props.interventionsFilters.filteredAndSortedInterventions,
            nextProps.interventionsFilters.filteredAndSortedInterventions,
            true
        );

        return filteredAndSortedInterventionsChanged || selectedTabChanged || selectedDayChanged || daysChanged;
    }

    componentDidMount() {
        this.generateDays(moment().startOf("day"));
        this.props.setSelectedDay(this.props.interventionsFilters.selectedDay, {
            ...this.props.interventionsFilters,
        });
    }

    generateDays(day) {
        let days = [];

        let currentIndex = 0;
        let currentDay = day.add(-3, "day");

        while (currentIndex < this.state.nbDaysToDisplay) {
            days.push(currentDay);
            currentDay = moment(currentDay.clone().add(1, "day"));
            currentIndex++;
        }

        let selectedTab = days.findIndex((d) => d.isSame(this.props.interventionsFilters.selectedDay, "day"));

        this.setState({ days, selectedTab });
    }

    handleChange = (event, value) => {
        this.changeSelectedDay(value);
    };

    handleChangeIndex = (index) => {
        this.changeSelectedDay(index);
    };

    changeSelectedDay(index) {
        this.setState({ selectedTab: index });
        let day = this.state.days[index];
        this.props.setSelectedDay(day.clone(), {
            ...this.props.interventionsFilters,
        });
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        let tabs = [];
        const { classes } = this.props;

        this.state.days.forEach((d, i) => {
            tabs.push({
                dayOfWeek: d.format("ddd"),
                dayOfMonth: d.format("DD"),
                content: (
                    <TabContainer key={i}>
                        <DayTab
                            globalContainer={this.props.globalContainer}
                            day={d}
                            selectedDay={this.props.interventionsFilters.selectedDay}
                            filteredAndSortedInterventions={
                                this.props.interventionsFilters.filteredAndSortedInterventions
                            }
                            interventionsFilters={this.props.interventionsFilters}
                            setFilteredAndSortedInterventions={this.props.setFilteredAndSortedInterventions}
                        />
                    </TabContainer>
                ),
            });
        });

        return (
            <div>
                <AppBar position="static" color="default" className="filters-card">
                    <Tabs
                        value={this.state.selectedTab}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                    >
                        {tabs.map((t, i) => (
                            <Tab key={i} classes={classes} label={t.dayOfWeek + " " + t.dayOfMonth} />
                        ))}
                    </Tabs>
                </AppBar>
                {tabs.length > 0 ? (
                    <SwipeableViews axis="x" index={this.state.selectedTab} onChangeIndex={this.handleChangeIndex}>
                        {tabs.map((t) => t.content)}
                    </SwipeableViews>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedDay: (selectedDay, interventionsFilters) =>
            dispatch(setSelectedDay(selectedDay, interventionsFilters)),
        setFilteredAndSortedInterventions: (interventionsFilters) =>
            dispatch(setFilteredAndSortedInterventions(interventionsFilters)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(DailyListMode);
